import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useServiceData } from '../../hooks/useServiceData'
import { useSubServiceData } from '../../hooks/useSubServiceData'
import './TextBlocksBlock.css'

const TextBlocksBlock = () => {
  const { slug, subSlug } = useParams()

  const { data: service } = useServiceData(subSlug ? null : slug)
  const { data: subService } = useSubServiceData(subSlug ? slug : null, subSlug)

  const blocks = useMemo(() => {
    const raw = subSlug ? subService?.textBlocks : service?.textBlocks
    if (!raw || raw.length === 0) return []
    return [...raw].sort((a, b) => a.order - b.order)
  }, [service, subService, subSlug])

  if (blocks.length === 0) return null

  return (
    <section className="text-blocks-block" aria-label="Дополнительная информация">
      <div className="text-blocks-block__inner">
        {blocks.map((item, index) => (
          <div className="text-blocks-block__item" key={`${item.heading}-${index}`}>
            {item.heading && <h3 className="text-blocks-block__heading">{item.heading}</h3>}
            {item.body && <p className="text-blocks-block__body">{item.body}</p>}
          </div>
        ))}
      </div>
    </section>
  )
}

export default TextBlocksBlock
